import styled from "styled-components";

export const ManifestWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const ManifestInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
